import { render, staticRenderFns } from "./modalDenegarCambios.vue?vue&type=template&id=38454338"
import script from "./modalDenegarCambios.vue?vue&type=script&lang=js"
export * from "./modalDenegarCambios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports